var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticStyle:{"border-radius":"1rem"},attrs:{"color":"#F5F7F9","flat":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"d-flex"},[_c('span',{staticClass:"font-weight-bold mr-2"},[_vm._v(_vm._s(_vm.name))])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }